import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import SectionHead from './SectionHead';
import Reveal from './Reveal';
import { useLang } from '@/context/LanguageContext';

export default function FAQ() {
  const { t } = useLang();
  return (
    <section id="faq" className="py-24 lg:py-32" data-testid="faq-section">
      <div className="mx-auto max-w-4xl px-5 sm:px-8">
        <SectionHead eyebrow={t.faq.eyebrow} title={t.faq.title} align="center" />
        <Reveal delay={0.1} className="mt-12">
          <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
            {t.faq.items.map((item, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="rounded-xl border border-white/10 bg-panel/60 px-6"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger
                  data-testid={`faq-item-${i}-trigger`}
                  className="py-5 text-left font-display text-base font-bold text-white hover:text-pulse hover:no-underline sm:text-lg"
                >
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-sm leading-relaxed text-slate-400" data-testid={`faq-item-${i}-content`}>
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
